import React, { useEffect, useMemo, useState } from 'react';
import { consultantSimulationTips, regularUserSimulationTips, SimulationTipType } from './simulationTips';
import { useSelector } from 'react-redux';
import { hasConsultantOrResearcherPermission } from '../../../reducers/AuthenticationReducer/AuthenticationSelector';
import { convertToLink } from '../../FlashMessages/ClickableMessage';
import { useIntl } from 'react-intl';
import { formatMessageHelper, FormattedMessageHelper } from '../../../shared/helpers/internationalization';
import Immutable from 'immutable';
import { progressSimulationIdSelector } from '../../../reducers/SimulationReducer/ProgressReducer/ProgressSelector';
import './SimulationTip.scss';

// we use module operator to deterministically get simulation tip depending on simulation id
function getSimulationTipById(isRegularUser: boolean, activeSimulationId: string | null) {
  if (!activeSimulationId) {
    return null;
  }
  const simulationNumber = activeSimulationId

    .split('')
    .map(str => str.charCodeAt(0))
    .reduce((acc, item) => acc + item, 0);

  const tips = isRegularUser ? regularUserSimulationTips : consultantSimulationTips;

  const randomIndex = simulationNumber % tips.length;

  return tips[randomIndex];
}

export const SimulationTip = () => {
  const isRegularUser = !useSelector(hasConsultantOrResearcherPermission);
  const activeSimulationId = useSelector(progressSimulationIdSelector) as string | null;

  const simulationTip = useMemo(() => getSimulationTipById(isRegularUser, activeSimulationId), [isRegularUser, activeSimulationId]);
  const [stateTip, setStateTip] = useState<SimulationTipType | null>(null);

  // use effect to not hide tip when we cancel simulation
  useEffect(() => {
    if (simulationTip) {
      setStateTip(simulationTip);
    }
  }, [simulationTip]);

  const intl = useIntl();

  if (!stateTip) {
    return null;
  }

  const text = formatMessageHelper(intl, stateTip.text);
  const linkKeys = Object.keys(stateTip.links).map(key => formatMessageHelper(intl, key));
  const linkUrls = Object.values(stateTip.links);

  return (
    <div className={'simulation__tip'}>
      <h4 className={'simulation__tip-title'}>
        <FormattedMessageHelper id={'simulationTip.title'} />
      </h4>
      <div className={'simulation__tip-content'}>
        {convertToLink(text, linkKeys, linkUrls, undefined, undefined, Immutable.fromJS({ target: '_blank', rel: 'noopener noreferrer' }))}
      </div>
    </div>
  );
};
